const alertBold = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M15.25 8A7.25 7.25 0 1 1 .75 8a7.25 7.25 0 0 1 14.5 0m-6.5 3.49v-1.5h-1.5v1.5zm0-2.49V4.51h-1.5V9z" clip-rule="evenodd"/></svg>',
};

export { alertBold as default };
